<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--team-add-user">
    <!-- メインコンテンツエリア -->
    <main class="l-main">
      <breadcrumb :breadcrumb-data="breadcrumbData" />

      <!-- メインコンテンツ: 上段共通エリア -->
      <div class="l-main-head">
        <div class="c-title u-w100p">
          <div class="c-title__text c-title__text--blue u-fs34">
            <span v-if="user">ユーザー編集</span>
            <span v-else>ユーザー追加</span>
          </div>
          <div class="c-text u-w100p">
            <span v-if="user">名前、権限の変更、パスワードの初期化が行えます</span>
            <span v-else>追加するユーザーのメールアドレス（ログインID）と名前・権限を設定してください。</span>
          </div>
        </div>
      </div>
      <!-- /メインコンテンツ: 上段共通エリア -->

      <!-- ユーザー情報入力エリア -->
      <div class="l-main-content">
        <admin-user-edit-form :account="account" :user="user" />
      </div>
      <!-- /ユーザー情報入力エリア -->
    </main>
    <!-- /メインコンテンツエリア -->
  </div>
  <!-- /ページ内容 -->
</template>

<script>
export default {
  props: {
    breadcrumbData: Array,
    account: Object,
    user: Object
  },
  computed: {
  }
};
</script>
